import { FC } from "react";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { useCategoryOptions } from "../../../CategoriesList/CategoriesList";
import CategoriesFieldWeb from "./layouts/CategoriesField.web";
import CategoriesFieldMob from "./layouts/CategoriesField.mob";

const CategoriesFieldComponent = withConditionalComponent(CategoriesFieldWeb, CategoriesFieldMob);

type CategoriesFieldProps = {
  value?: string;
  onChange?: (value: string) => void;
};

const CategoriesField: FC<CategoriesFieldProps> = ({ value, onChange }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const { options, isFetching, error, hasData } = useCategoryOptions();

  if (error || (!isFetching && !hasData)) return null;

  return <CategoriesFieldComponent trigger={isLargeScreen} props={{ value, onChange, options, isFetching }} />;
};

export default CategoriesField;
